export default "__VITE_ASSET__C0A8I1kt__"